export default {"src":"https://fishbrain.com/_next/static/media/ic_weather_day_326.6c97a6f0.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};